import Reporting from "../views/admin/Reporting.vue";

const securityRoutes = [
  {
    path: "/reporting",
    name: "reporting",
    component: Reporting,
    meta: {
      requiresAuth: ["ADM", "SEC"],
      title: "Reporting",
      navbarTitle: "Reporting",
      navbarIcon: "mdi-clipboard-list"
    }
  }
];

export default securityRoutes;
